<template lang="pug">
  .filters-key
    a.filters-key__open-modal(@click.stop="toggleModal" ref="openBtn" tabindex="0")
      i.ico-info
      | {{ $root.filterKeyLabel }}
    .filters-key__modal(:data-open="open")
      .filters-key__modal-inner
        .filters-key__modal-content(v-if="$store.state.settings.includedHTML" v-html="$store.state.settings.includedHTML.filterKey" ref="modalContent")
        button.btn.filters-key__close-modal(@click.stop="toggleModal" ref="closeBtn") Close Modal#[i.ico-close]
      .filters-key__icon-refs(style="display: none;")
        SVGLoader(v-for="icon in icons" :key="icon" :icon="icon" :width="18" :height="18" :ref="`ico-${icon}`")
</template>

<script>
import SVGLoader from './global/SVGLoader.vue';
export default {
  components: {
    SVGLoader
  },
  data: function () {
    const iconsUsed = ['award', 'house'];
    return {
      open: false,
      icons: iconsUsed
    };
  },
  methods: {
    toggleModal: function () {
      this.open = !this.open;
      if (!document.body.classList.contains('using-mouse')) {
        if (this.open)
          this.$refs.closeBtn.focus();
        else
          this.$refs.openBtn.focus();
      }
    },
    checkCloseModal: function (e) {
      if (e.type === 'click' && this.$refs.modalContent.contains(e.srcElement)) return;
      else if (e.type === 'keydown' && e.key !== 'Escape') return;
      this.open = false;
    }
  },
  mounted() {
    document.addEventListener("click", this.checkCloseModal);
    window.addEventListener("keydown", this.checkCloseModal);

    document.querySelectorAll('.filters-key i.replace').forEach((i) => {
      i.outerHTML = this.$refs[`ico-${i.dataset.icon}`][0].$el.outerHTML.replace('svg-icon', `svg-icon ${i.dataset.class}`);
    });
  },
  beforeDestroy: function () {
    this.filterState = [];

    document.removeEventListener("click", this.checkCloseModal);
    document.removeEventListener("keydown", this.checkCloseModal);
  },
};
</script>